module.exports = __webpack_public_path__ + "img/usd-coin.7f71f7d8.png";